export class SetupAwsPrivateLinkRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ramResourceShareArn",
            "baseName": "ramResourceShareArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetupAwsPrivateLinkRequest.attributeTypeMap;
    }
    constructor() {
    }
}
